import HTMLReactParser from "html-react-parser";
import React, { useEffect, useState } from "react";

const InvestMessageDetails = () => {
  const [messageData, setMessageData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://api.wlffinance.org/api/user/investment/plan/message/view`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setMessageData(data?.data);
        setLoading(false);
      });
  }, []);

  if(loading){
    return;
  }

  return (
    <>
      <div className="mobile-news-details-section news-details-area">
        <div className="container">
          <div className="news-details">
            <main>
              <div className="news-details-main">
                <div className="news-title">
                  <h5 className="pb-3">{messageData?.title}</h5>
                </div>
                <div className="news-detail-all message-details">
                  {messageData?.dis ? HTMLReactParser(messageData?.dis) : ""}
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvestMessageDetails;
